
export const numberDecimalFormat = (params:any) =>{
    if(params.value){
        return formatter.format(params.value).toString();
    }
    return '';
}

export const percentFormat = (params:any) =>{
    if(params.value !== null && params.value !== undefined && params.value !== ''){
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(params.value) + '%';
    }
    return '';
}

export const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});